import * as Sentry from '@sentry/react';

import { openNotification } from '@/components/UI/DesktopNotifications';

export interface CustomEventMap {
  rasplayerror: CustomEvent;
}

const cache: Record<string, HTMLAudioElement> = {};
let audioErrSent = false;

export default async function play(file: string) {
  try {
    if (!cache[file]) {
      cache[file] = new Audio(file);
    }

    return await cache[file].play();
  } catch (_error) {
    try {
      window.dispatchEvent(new CustomEvent('rasplayerror'));
    } catch (error2) {
      Sentry.captureException(error2);
    }

    try {
      if (!audioErrSent) {
        audioErrSent = true;

        const platform = `${
          typeof navigator !== 'undefined' &&
          (navigator.userAgentData?.platform || navigator.platform)
        }`;
        const isAppleDevice = platform.startsWith('i'); // iOS devices cant play audio anyways generally

        if (!isAppleDevice) {
          openNotification(
            'RAS App',
            'RAS was unable to play notification sounds. Please see the app.',
            undefined,
            'audioerr',
          );
        }
      }
    } catch (_error2) {
      //
    }
  }
}
